import { useMediaQuery } from '@mui/material'
import theme from '../theme'

export const useIsMobile = (): boolean => {
    return useMediaQuery(theme.breakpoints.down('sm'))
}
